import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import usePersonalCyberFlow from "../../../../hooks/usePersonalCyberFlow";
import { STEP_NAME_START } from "../../../../hooks/data";
import usePersonalCyberFormData from "../../../../hooks/usePersonalCyberFormData";
import { selectLoginTokenInfo } from "../../../../redux/features/loginRegisterSlice";
import BasicInfo from "../../../common/BasicInfo/BasicInfo";
import BottomStickyBtnLayout from "../../layouts/BottomStickyBtnLayout";
import PersonalCyberJourneyLayout from "../../layouts/PersonalCyberJourneyLayout";
import DocumentsReadyInfo from "./documentsReadyInfo/documentsReadyInfo";
import "./startPage.css";

const PERSONAL_CYBER_BASIC_INFO_FORM = "PERSONAL_CYBER_BASIC_INFO_FORM";

const StartPage = ({ onClose }) => {
  const { handleNextSubstep, currentSubstepIndex, currentStep, handlePrevSubstep } =
    usePersonalCyberFlow();
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const isLoggedIn = !!loginTokenInfo;
  const translate = useLanguageTranslate();

  // Form data hook for saving basic info
  const { savePersonalCyberDataInRedux, redux_form_data: savedBasicInfo } = usePersonalCyberFormData(
    PERSONAL_CYBER_BASIC_INFO_FORM,
    () => {}
  );

  // Convert Redux data to BasicInfo format
  const initialValues = useMemo(() => {
    if (!savedBasicInfo) return null;
    const birthDateParts = savedBasicInfo.birthDate?.split("-") || [];
    return {
      fullName: savedBasicInfo.fullName || "",
      email: savedBasicInfo.email || "",
      mobile: savedBasicInfo.contactNumber || "",
      year: birthDateParts[0] || "",
      month: birthDateParts[1] || "",
      day: birthDateParts[2] || "",
      fullDate: savedBasicInfo.birthDate || "",
    };
  }, [savedBasicInfo]);

  // If logged in, skip to documents ready step
  useEffect(() => {
    if (
      isLoggedIn &&
      currentStep?.name === STEP_NAME_START &&
      currentSubstepIndex !== 1
    ) {
      handleNextSubstep();
    }
  }, [isLoggedIn, currentStep, currentSubstepIndex, handleNextSubstep]);

  const handleBackToForm = () => {
    handlePrevSubstep();
  };

  const handleSaveBasicInfo = async (basicInfo) => {
    // Save basic info to Redux for use in API calls
    console.log("Personal Cyber Basic Info:", basicInfo);
    await savePersonalCyberDataInRedux(basicInfo);
  };

  return (
    <div className="flex flex-col items-center gap-6 bg-white">
      {isLoggedIn ? (
        currentSubstepIndex === 1 ? (
          <DocumentsReadyInfo
            continueClickHandler={handleNextSubstep}
            hide_back_btn={true}
            show_close_btn={true}
            onClose={onClose}
            isFirstPage={true}
          />
        ) : (
          <div className="p-4">Loading...</div>
        )
      ) : (
        <>
          {currentSubstepIndex === 0 ? (
            <BasicInfo
              continueClickHandler={handleNextSubstep}
              onClose={onClose}
              title={translate(
                "New Personal Cyber Insurance",
                "التأمين السيبراني الشخصي"
              )}
              subtitle={translate(
                "Welcome! Let's start with some basic information.",
                "مرحبًا بك! لنبدأ ببعض المعلومات الأساسية."
              )}
              onSaveBasicInfo={handleSaveBasicInfo}
              JourneyLayoutComponent={PersonalCyberJourneyLayout}
              BottomStickyBtnLayoutComponent={BottomStickyBtnLayout}
              initialValues={initialValues}
              storageKey="personal_cyber_basic_info"
            />
          ) : currentSubstepIndex === 1 ? (
            <DocumentsReadyInfo
              continueClickHandler={handleNextSubstep}
              hide_back_btn={false}
              show_close_btn={false}
              onClose={onClose}
              customBackHandler={handleBackToForm}
              isFirstPage={false}
            />
          ) : (
            <div className="p-4">Loading...</div>
          )}
        </>
      )}
    </div>
  );
};

export default StartPage;
